/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  PaginatedUploadScheduleList,
  PatchedUploadScheduleRequest,
  UploadSchedule,
  UploadScheduleCreate,
  UploadScheduleCreateRequest,
  UploadScheduleListParams,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 채널의 예약 업로드 스케줄 목록을 반환합니다.
 * @summary 예약 업로드 스케줄 목록
 */
export const uploadScheduleList = (
  channelPk: string,
  params?: UploadScheduleListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedUploadScheduleList>(
    {
      url: `/api/channels/${channelPk}/upload-schedules/`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getUploadScheduleListQueryKey = (
  channelPk?: string,
  params?: UploadScheduleListParams,
) => {
  return [
    `/api/channels/${channelPk}/upload-schedules/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getUploadScheduleListQueryOptions = <
  TData = Awaited<ReturnType<typeof uploadScheduleList>>,
  TError = ErrorType<unknown>,
>(
  channelPk: string,
  params?: UploadScheduleListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof uploadScheduleList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getUploadScheduleListQueryKey(channelPk, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof uploadScheduleList>>
  > = ({ signal }) =>
    uploadScheduleList(channelPk, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!channelPk,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof uploadScheduleList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UploadScheduleListQueryResult = NonNullable<
  Awaited<ReturnType<typeof uploadScheduleList>>
>;
export type UploadScheduleListQueryError = ErrorType<unknown>;

export function useUploadScheduleList<
  TData = Awaited<ReturnType<typeof uploadScheduleList>>,
  TError = ErrorType<unknown>,
>(
  channelPk: string,
  params: undefined | UploadScheduleListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof uploadScheduleList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof uploadScheduleList>>,
          TError,
          Awaited<ReturnType<typeof uploadScheduleList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUploadScheduleList<
  TData = Awaited<ReturnType<typeof uploadScheduleList>>,
  TError = ErrorType<unknown>,
>(
  channelPk: string,
  params?: UploadScheduleListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof uploadScheduleList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof uploadScheduleList>>,
          TError,
          Awaited<ReturnType<typeof uploadScheduleList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUploadScheduleList<
  TData = Awaited<ReturnType<typeof uploadScheduleList>>,
  TError = ErrorType<unknown>,
>(
  channelPk: string,
  params?: UploadScheduleListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof uploadScheduleList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 예약 업로드 스케줄 목록
 */

export function useUploadScheduleList<
  TData = Awaited<ReturnType<typeof uploadScheduleList>>,
  TError = ErrorType<unknown>,
>(
  channelPk: string,
  params?: UploadScheduleListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof uploadScheduleList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getUploadScheduleListQueryOptions(
    channelPk,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 채널에 새 예약 업로드 스케줄을 등록합니다.
 * @summary 예약 업로드 스케줄 생성
 */
export const uploadScheduleCreate = (
  channelPk: string,
  uploadScheduleCreateRequest: BodyType<UploadScheduleCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<UploadScheduleCreate>(
    {
      url: `/api/channels/${channelPk}/upload-schedules/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: uploadScheduleCreateRequest,
      signal,
    },
    options,
  );
};

export const getUploadScheduleCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadScheduleCreate>>,
    TError,
    { channelPk: string; data: BodyType<UploadScheduleCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadScheduleCreate>>,
  TError,
  { channelPk: string; data: BodyType<UploadScheduleCreateRequest> },
  TContext
> => {
  const mutationKey = ["uploadScheduleCreate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadScheduleCreate>>,
    { channelPk: string; data: BodyType<UploadScheduleCreateRequest> }
  > = (props) => {
    const { channelPk, data } = props ?? {};

    return uploadScheduleCreate(channelPk, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadScheduleCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadScheduleCreate>>
>;
export type UploadScheduleCreateMutationBody =
  BodyType<UploadScheduleCreateRequest>;
export type UploadScheduleCreateMutationError = ErrorType<unknown>;

/**
 * @summary 예약 업로드 스케줄 생성
 */
export const useUploadScheduleCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadScheduleCreate>>,
      TError,
      { channelPk: string; data: BodyType<UploadScheduleCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadScheduleCreate>>,
  TError,
  { channelPk: string; data: BodyType<UploadScheduleCreateRequest> },
  TContext
> => {
  const mutationOptions = getUploadScheduleCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 스케줄을 부분 수정합니다.
 * @summary 예약 업로드 스케줄 수정
 */
export const uploadSchedulePartialUpdate = (
  channelPk: string,
  id: string,
  patchedUploadScheduleRequest: BodyType<PatchedUploadScheduleRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UploadSchedule>(
    {
      url: `/api/channels/${channelPk}/upload-schedules/${id}/`,
      method: "PATCH",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: patchedUploadScheduleRequest,
    },
    options,
  );
};

export const getUploadSchedulePartialUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadSchedulePartialUpdate>>,
    TError,
    {
      channelPk: string;
      id: string;
      data: BodyType<PatchedUploadScheduleRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadSchedulePartialUpdate>>,
  TError,
  {
    channelPk: string;
    id: string;
    data: BodyType<PatchedUploadScheduleRequest>;
  },
  TContext
> => {
  const mutationKey = ["uploadSchedulePartialUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadSchedulePartialUpdate>>,
    {
      channelPk: string;
      id: string;
      data: BodyType<PatchedUploadScheduleRequest>;
    }
  > = (props) => {
    const { channelPk, id, data } = props ?? {};

    return uploadSchedulePartialUpdate(channelPk, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadSchedulePartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadSchedulePartialUpdate>>
>;
export type UploadSchedulePartialUpdateMutationBody =
  BodyType<PatchedUploadScheduleRequest>;
export type UploadSchedulePartialUpdateMutationError = ErrorType<unknown>;

/**
 * @summary 예약 업로드 스케줄 수정
 */
export const useUploadSchedulePartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadSchedulePartialUpdate>>,
      TError,
      {
        channelPk: string;
        id: string;
        data: BodyType<PatchedUploadScheduleRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadSchedulePartialUpdate>>,
  TError,
  {
    channelPk: string;
    id: string;
    data: BodyType<PatchedUploadScheduleRequest>;
  },
  TContext
> => {
  const mutationOptions =
    getUploadSchedulePartialUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 스케줄을 삭제합니다.
 * @summary 예약 업로드 스케줄 삭제
 */
export const uploadScheduleDestroy = (
  channelPk: string,
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    {
      url: `/api/channels/${channelPk}/upload-schedules/${id}/`,
      method: "DELETE",
    },
    options,
  );
};

export const getUploadScheduleDestroyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadScheduleDestroy>>,
    TError,
    { channelPk: string; id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadScheduleDestroy>>,
  TError,
  { channelPk: string; id: string },
  TContext
> => {
  const mutationKey = ["uploadScheduleDestroy"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadScheduleDestroy>>,
    { channelPk: string; id: string }
  > = (props) => {
    const { channelPk, id } = props ?? {};

    return uploadScheduleDestroy(channelPk, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadScheduleDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadScheduleDestroy>>
>;

export type UploadScheduleDestroyMutationError = ErrorType<unknown>;

/**
 * @summary 예약 업로드 스케줄 삭제
 */
export const useUploadScheduleDestroy = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadScheduleDestroy>>,
      TError,
      { channelPk: string; id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadScheduleDestroy>>,
  TError,
  { channelPk: string; id: string },
  TContext
> => {
  const mutationOptions = getUploadScheduleDestroyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
